import type { CalendarEvent } from '@/features/schedule/context/Data'

// FullCalendar can emit EventChangeArg for a *single instance* of a recurring event.
// Depending on how the event was created/expanded, the instance id may not match the
// canonical CalendarEvent.id we store in context.
//
// We try multiple strategies to find the stored event:
// 1) id match
// 2) timeslotId match (stable backend identifier)
// 3) timeslotContentId match (sometimes present on smart slots)
export function findStoredEventForChange(
	events: CalendarEvent[],
	fcEvent: { id?: string; extendedProps?: any }
): CalendarEvent | undefined {
	if (!Array.isArray(events) || events.length === 0) return undefined

	let fcId: string | undefined
	try {
		fcId = fcEvent?.id
	} catch {
		// FullCalendar can invalidate an event instance while eventChange is still
		// being processed, so fall back to stable extendedProps identifiers.
		fcId = undefined
	}
	if (fcId) {
		const byId = events.find((e) => e.id === fcId)
		if (byId) return byId
	}

	const fcTimeslotId = fcEvent?.extendedProps?.timeslotId
	if (typeof fcTimeslotId === 'number') {
		const byTimeslotId = events.find((e) => e.timeslotId === fcTimeslotId)
		if (byTimeslotId) return byTimeslotId
	}

	const fcTimeslotContentId = fcEvent?.extendedProps?.timeslotContentId
	if (typeof fcTimeslotContentId === 'number') {
		const byTimeslotContentId = events.find(
			(e) => e.timeslotContentId === fcTimeslotContentId
		)
		if (byTimeslotContentId) return byTimeslotContentId
	}

	return undefined
}
